import {ScoreCalculator} from 'domain/ports';
import {Question} from "domain/entities/Question";
import {calculateQuestionScore} from 'core/calculation/scoreCalculator';

/**
 * Implementación por defecto del calculador de puntuaciones
 */
export class DefaultScoreCalculator implements ScoreCalculator {
  /**
   * Calcula la puntuación para una pregunta específica
   * @param question Pregunta para la que se calculará la puntuación
   * @param answer Respuesta dada a la pregunta
   * @param scale Escala de valores para las respuestas
   */
  calculateScore(
    question: Question, 
    answer: any, 
    scale?: { [key: string]: number }
  ): number {
    // Delegamos el cálculo a la función pura del core
    return calculateQuestionScore(
      question.type,
      answer,
      scale,
      question.inverted || false
    );
  }
  
  /**
   * Calcula las puntuaciones totales por categoría
   * @param scores Objeto con las puntuaciones individuales por pregunta
   * @param questions Preguntas con sus categorías
   */
  calculateCategoryTotals(
    scores: { [key: string]: number }, 
    questions: Question[]
  ): { [category: string]: number } {
    const categoryTotals: { [category: string]: number } = {};
    
    questions.forEach(question => {
      const score = scores[question.id] || 0;
      const categoria = question.category || 'Sin Categoría';
      
      categoryTotals[categoria] = (categoryTotals[categoria] || 0) + score;
    });
    
    return categoryTotals;
  }
  
  /**
   * Calcula las puntuaciones totales por dominio
   * @param scores Objeto con las puntuaciones individuales por pregunta
   * @param questions Preguntas con sus dominios
   */
  calculateDomainTotals(
    scores: { [key: string]: number }, 
    questions: Question[]
  ): { [domain: string]: number } {
    const domainTotals: { [domain: string]: number } = {};
    
    questions.forEach(question => {
      const score = scores[question.id] || 0;
      const dominio = question.domain || 'Sin Dominio';
      
      domainTotals[dominio] = (domainTotals[dominio] || 0) + score;
    });
    
    return domainTotals;
  }
  
  /**
   * Calcula las puntuaciones totales por dimensión
   * @param scores Objeto con las puntuaciones individuales por pregunta
   * @param questions Preguntas con sus dimensiones
   */
  calculateDimensionTotals(
    scores: { [key: string]: number }, 
    questions: Question[]
  ): { [dimension: string]: number } {
    const dimensionTotals: { [dimension: string]: number } = {};
    
    questions.forEach(question => {
      const score = scores[question.id] || 0;
      const dimension = question.dimension || 'Sin Dimensión';
      
      dimensionTotals[dimension] = (dimensionTotals[dimension] || 0) + score;
    });
    
    return dimensionTotals;
  }
}
